/**
 * LA CAJA DE ESCRIBIR DEL CHAT: cuánto cabe y de quién es lo que hay a medias (12-10, al
 * pasar a mano la pestaña Devolución del cuaderno).
 *
 * 1. EL TOPE. Un mensaje no tenía tope de largo y entró uno de 10.121 caracteres seguidos,
 *    que dejó la conversación del cliente en blanco y el panel del equipo con el botón de
 *    enviar fuera de la pantalla. El servidor rechaza lo que pase de aquí
 *    (`backend/core/mensajes_pendientes.MAX_LARGO_MENSAJE`): si cambia allí, cambia aquí.
 *
 * 2. UN BORRADOR POR CONVERSACIÓN. En el panel del equipo la caja era una sola para todas:
 *    se escribía para un cliente, se abría a otro y el texto seguía ahí, a un Intro de
 *    mandárselo al que no es. Vaciarla a secas pierde lo que se estaba escribiendo, así que
 *    cada conversación guarda lo suyo y lo recupera al volver.
 *
 * Todo puro: los borradores son un objeto `{ [idDeLaConversacion]: { texto, adjunto } }`
 * que nunca se cambia en el sitio (cada función devuelve uno nuevo).
 */

export const MAX_LARGO_MENSAJE = 4000;

/** ¿Ya no cabe ni una letra más? Para avisar debajo de la caja. */
export const haLlegadoAlTope = (texto) => String(texto || '').length >= MAX_LARGO_MENSAJE;

/** Lo que se queda en la caja: lo pegado de más se corta, igual que al teclear. */
export const recortarAlTope = (texto) => String(texto || '').slice(0, MAX_LARGO_MENSAJE);

const CAJA_VACIA = Object.freeze({ texto: '', adjunto: null });

const estaVacia = (caja) => !String(caja?.texto || '').trim() && !caja?.adjunto;

/** Lo que había a medias para esa conversación (la caja vacía si no había nada). */
export const borradorDe = (borradores, conversacion) => {
    const b = conversacion ? (borradores || {})[conversacion] : null;
    return b ? { texto: b.texto || '', adjunto: b.adjunto || null } : { ...CAJA_VACIA };
};

/** Guarda la caja de esa conversación. Una caja vacía no se guarda: se borra lo que hubiera. */
export const guardarBorrador = (borradores, conversacion, caja) => {
    const nuevos = { ...(borradores || {}) };
    if (!conversacion) return nuevos;
    if (estaVacia(caja)) delete nuevos[conversacion];
    else nuevos[conversacion] = { texto: caja.texto || '', adjunto: caja.adjunto || null };
    return nuevos;
};

/**
 * Al pasar de una conversación a otra: lo que había en la caja se queda guardado en la que
 * se deja, y la caja pasa a tener lo de la que se abre.
 *
 * @returns {{ borradores: object, caja: { texto: string, adjunto: object|null } }}
 */
export const cambiarDeConversacion = (borradores, anterior, cajaActual, nueva) => {
    const guardados = guardarBorrador(borradores, anterior, cajaActual);
    return { borradores: guardados, caja: borradorDe(guardados, nueva) };
};
